import { Table, TableBody, TableHead } from "@mui/material";

import { GqlCostSpecProtocol } from "~/__generated__";

import ProjectCostVisitTableRow from "./ProjectCostVisitTableRow";

type Props = {
    protocols: GqlCostSpecProtocol[];
};

export default function ProjectCostVisitTable({ protocols }: Props) {
    return (
        <Table sx={{ mb: 8 }}>
            <TableHead></TableHead>
            <TableBody>
                {protocols.map(protocol => (
                    <ProjectCostVisitTableRow key={protocol.id} protocol={protocol} />
                ))}
            </TableBody>
        </Table>
    );
}
